import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import cn from 'classnames/bind';
import { ARTICLES_TYPE } from 'snippets/latesArticles';

// Components
import AuthorContentPhone from './AuthorContentPhone';
import AuthorContentTablet from './AuthorContentTablet';
import AuthorContentDesktop from './AuthorContentDesktop';

// Styles
import styles from './styles.styl';

const cx = cn.bind(styles);

const ARTICLES_LENGTH = 9;

function AuthorContent({ promos, slug, paginationHref, changePage }) {
  const page = useSelector(state => state.author.page);
  const isServer = useSelector(state => state.responsive.isServer);
  const isOnlyDesktop = useSelector(state => state.responsive.isOnlyDesktop);
  const isNotebook = useSelector(state => state.responsive.isNotebook);
  const isVerticalSmallTablet = useSelector(state => state.responsive.isVerticalSmallTablet);
  const isDesctop = useMemo(() => (isServer ? isOnlyDesktop : isOnlyDesktop && !isNotebook), [
    isNotebook,
    isOnlyDesktop,
    isServer,
  ]);
  const isLoading = useSelector(state => state.author.isLoadingArticles);

  const content = useSelector(state => state.author.pages[slug]);

  const articlesData = content[ARTICLES_TYPE];

  const articles = useMemo(
    () => ({
      page,
      total: articlesData ? Math.ceil(articlesData.total / ARTICLES_LENGTH) : 0,
      items: articlesData && articlesData.items ? articlesData.items : [],
    }),
    [articlesData, page],
  );

  return (
    <div className={cx('AuthorContent')}>
      {isVerticalSmallTablet ? (
        <AuthorContentPhone
          articles={articles}
          sidebar={content.sidebar}
          promos={promos}
          isLoading={isLoading}
          page={page}
          paginationHref={paginationHref}
          changePage={changePage}
        />
      ) : !isDesctop ? (
        <AuthorContentTablet
          articles={articles}
          sidebar={content.sidebar}
          promos={promos}
          isLoading={isLoading}
          page={page}
          paginationHref={paginationHref}
          changePage={changePage}
        />
      ) : (
        <AuthorContentDesktop
          articles={articles}
          sidebar={content.sidebar}
          promos={promos}
          isLoading={isLoading}
          page={page}
          paginationHref={paginationHref}
          changePage={changePage}
        />
      )}
    </div>
  );
}

AuthorContent.propTypes = {
  promos: PropTypes.array,
  slug: PropTypes.string,
  paginationHref: PropTypes.func,
  changePage: PropTypes.func,
};

AuthorContent.defaultProps = {
  promos: [],
};

export default AuthorContent;
